import { gql } from '@apollo/client'

// eslint-disable-next-line import/prefer-default-export
export const STARS_IN_CATEGORY_QUERY = gql`
  query artistsFromCategories(
    $firstOrLastName_Istartswith: String
    $first: Int
    $orderBy: String
    $status: String
    $categories_Contains: [ID!]
    $categoryWithChild_Exact: String
    $after: String
    $venueCoordinates: String
  ) {
    allArtists(
      first: $first
      orderBy: $orderBy
      status: $status
      categoryWithChild_Exact: $categoryWithChild_Exact
      firstOrLastName_Istartswith: $firstOrLastName_Istartswith
      categories_Contains: $categories_Contains
      after: $after
      venueCoordinates: $venueCoordinates
    ) {
      edges {
        node {
          id
          fullName
          file {
            extension
            path
          }
          slug
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`
